<div class="user">
  <div class="block block_first">
    <div class="user__photo">
      <tui-avatar
        [src]="chat && chat.userPhotoPath ? (chat.userPhotoPath | safe: 'url') : (chat?.title ?? '' | tuiInitials)"
        [size]="'l'"
        [round]="true"
        [style.background]="chat?.title ?? '' | tuiAutoColor"
      ></tui-avatar>
    </div>

    <app-link
      class="user__name"
      [routerLink]="'/association-users/' + userUnions?.id"
      [displayText]="chat?.title"
    ></app-link>
    <div class="user__status">{{ userTelegram?.status | userStatus: true }}</div>
  </div>

  <div *ngIf="userUnions?.organisationJobTitles?.length" class="user__info block block_info">
    <tui-data-list>
      <button
        *ngFor="let organisationJobTitle of userUnions?.organisationJobTitles | jobTitles"
        tuiOption
        class="organisation"
        [routerLink]="'/organisation/' + organisationJobTitle.organisationId"
      >
        <app-icon class="organisation__icon" [src]="'building-2'" size="24px"></app-icon>

        <span class="organisation__title">
          {{ organisationJobTitle | orgJobTitleDisplayableName }}
        </span>
      </button>
    </tui-data-list>
  </div>

  <div class="block">
    <tui-data-list>
      <button tuiOption class="notifications" (click)="onChangeNotificationsToggleValue()">
        <app-toggle [ngModel]="!!chat && chat.notificationSettings.muteFor === 0" [size]="'m'"></app-toggle>

        <span class="notifications__title">
          {{ 'common.labels.notifications' | translate }}
        </span>
      </button>
    </tui-data-list>
  </div>
</div>
